var map = {
	"./brands.fa.svg": [
		627,
		5
	],
	"./duotone.fa.svg": [
		628,
		6
	],
	"./light.fa.svg": [
		629,
		7
	],
	"./regular.fa.svg": [
		630,
		8
	],
	"./solid.fa.svg": [
		631,
		9
	],
	"./thin.fa.svg": [
		632,
		10
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 348;
module.exports = webpackAsyncContext;